import { Autocomplete, Grid, IconButton, TextField } from '@mui/material';
import { Controller, useWatch } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect } from 'react';
import moment from 'moment';

const DynamicOldMoneyReceipt = ({
  register,
  index,
  control,
  remove,
  fields,
  setValue,
  memberList,
}: any) => {
  const itemID = useWatch({
    control,
    name: `items.${index}.id`,
  });

  const yearSelect = useWatch({
    control,
    name: `items.${index}.year`,
  });

  const member_id = useWatch({
    control,
    name: `member_id`,
  });

  // ----------------------------------------------------
  // ❌ REMOVED payable-item effect
  // ----------------------------------------------------

  // Reset fields when member changes
  useEffect(() => {
    if (!member_id) {
      setValue(`items.${index}.year`, []);
      setValue(`items.${index}.id`, []);
      setValue(`items.${index}.collected_amount`, '');
    }
  }, [member_id]);

  // Membership expiry logic (kept same)
  useEffect(() => {
    if (
      (itemID === 2 || itemID === 41 || itemID === 42) &&
      memberList?.length === 1 &&
      memberList[0]?.user_member_membership_payment_expiry_date
    ) {
      const year = Array.from({ length: 3 }, (x, idx) => {
        const baseYear =
          moment(memberList[0].user_member_membership_payment_expiry_date)
            .utc()
            .year() + 1;

        return {
          label: String(baseYear + idx),
          value: String(baseYear + idx),
        };
      });

      setValue(`items.${index}.year`, year);
    }

    if (
      itemID === 3 &&
      memberList?.length === 1 &&
      memberList[0]?.user_member_id_card_expiry_date
    ) {
      const year = [
        {
          label: String(
            moment(memberList[0].user_member_id_card_expiry_date).utc().year() +
              1
          ),
          value: String(
            moment(memberList[0].user_member_id_card_expiry_date).utc().year() +
              1
          ),
        },
      ];

      setValue(`items.${index}.year`, year);
    }
  }, [itemID]);

  // Year auto expansion logic (kept same)
  useEffect(() => {
    if (
      (itemID === 2 || itemID === 41 || itemID === 42) &&
      yearSelect?.length === 1 &&
      !yearSelect[0]?.loopAdd &&
      !memberList[0]?.user_member_membership_payment_expiry_date
    ) {
      const base = Number(yearSelect[0].value);

      const year = Array.from({ length: 3 }, (_, idx) => ({
        label: String(base + idx),
        value: String(base + idx),
        loopAdd: true,
      }));

      setValue(`items.${index}.year`, year);
    }
  }, [yearSelect?.length]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems='center'
        sx={{
          margin: `0px 0 15px 0`,
          background: '#f8f9f9',
          borderRadius: '15px',
          py: '5px',
        }}
      >
        {/* Year Field */}
        <Grid item xs={12} md={12} lg={3}>
          <Controller
            control={control}
            name={`items.${index}.year`}
            render={({ field }) => (
              <Autocomplete
                multiple
                options={Array.from({ length: 100 }, (_, i) => {
                  const year = 2000 + i;
                  return { label: `${year}`, value: `${year}` };
                })}
                getOptionLabel={(option) => option.label}
                value={field.value || []}
                onChange={(e, newValue) => {
                  const uniqueValues = Array.from(
                    new Set(newValue.map((i) => i.value))
                  ).map((val) => newValue.find((i) => i.value === val));

                  field.onChange(uniqueValues);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='Select years'
                    placeholder='More...'
                  />
                )}
              />
            )}
          />
        </Grid>

        {/* Amount Field */}
        <Grid item xs={12} md={12} lg={3}>
          <TextField
            fullWidth
            required
            label='Amount'
            type='number'
            variant='outlined'
            {...register(`items.${index}.collected_amount`)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* Cheque No */}
        <Grid item xs={12} md={12} lg={4}>
          <TextField
            fullWidth
            label='Cheque No'
            type='text'
            variant='outlined'
            {...register(`items.${index}.cheque_no`)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* Remove Button */}
        {fields.length > 1 && (
          <Grid item>
            <IconButton onClick={() => remove(index)} color='error'>
              <DeleteIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default DynamicOldMoneyReceipt;
